
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTv = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 1201 1200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M945.043 327.494H256.771c-13.859 0-25.095 11.236-25.095 25.095v374.093c0 13.859 11.236 25.094 25.095 25.094h688.272c13.859 0 25.095-11.235 25.095-25.094V352.589c0-13.859-11.236-25.095-25.095-25.095zm-200.737 501.47H659.11v-33.651H542.705v33.651h-85.197c-12.022 0-21.769 9.746-21.769 21.769 0 12.021 9.745 21.768 21.769 21.768h286.798c12.022 0 21.769-9.745 21.769-21.768 0-12.022-9.746-21.769-21.769-21.769z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"60\" height=\"60\" viewBox=\"0 0 1201 1200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M945.043 327.494H256.771c-13.859 0-25.095 11.236-25.095 25.095v374.093c0 13.859 11.236 25.094 25.095 25.094h688.272c13.859 0 25.095-11.235 25.095-25.094V352.589c0-13.859-11.236-25.095-25.095-25.095zM744.306 828.964H659.11v-33.651H542.705v33.651h-85.197c-12.022 0-21.769 9.746-21.769 21.769 0 12.021 9.745 21.768 21.769 21.768h286.798c12.022 0 21.769-9.745 21.769-21.768 0-12.022-9.746-21.769-21.769-21.769z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/tv.bbd0de6ad2ad81c572d2a42a3622e540.svg"),
        {
          React: SvgTv,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      